module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [(_vm.$route.name !== '') ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.general_info) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/home'
    }
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.start) + " ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/device'
    }
  }, [_c('i', {
    staticClass: "icon-screen-smartphone"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.devices) + " ")])], 1), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/shunting'
    }
  }, [_c('i', {
    staticClass: "icon-wrench"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.shunttings) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.status_system) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/notifications',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.notifications))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/messages',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speech"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.messages))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/events',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-tag"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.events))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.informs) + "\n        ")]), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/maximeter',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.maximeters))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/export_data',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.export_inform))])], 1), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/energetic_inform',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-credit-card"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.inf_energetic))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/costs_inform',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-credit-card"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.inf_costs))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/invoice_simulation',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-chart"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.invoice_simulation))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/anuall_sumary',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-chart"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.annually_inform))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.app_info) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/info',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-info"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.sce_info))])], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-992d4a00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 565
// module chunks = 1